import React from 'react';
import emptyCartIcon from '../../../../../assets/images/empty_cart_icon.svg';

const EmptyCartModal: React.FC<any> = () => {
  return (
    <>
      <div className='flex flex-col border-none sm:border-none md:border lg:border items-center justify-center bg-white py-6 mt-0 sm:mt-0 md:mt-6 lg:mt-6 rounded-lg shadow-md'>
        <div className='px-0 sm:px-0 md:px-26 lg:px-32 mb-4 '>
          <img
            src={emptyCartIcon}
            alt='Empty cart'
            className='
                        min-h-[8rem] max-h-[8rem] min-w-30 max-w-50 
                        sm:min-h-[8rem] sm:max-h-[8rem] sm:min-w-30 sm:max-w-50  
                        md:min-h-[10rem] md:max-h-[10rem] md:min-w-30 md:max-w-[30rem]
                        lg:min-h-[10rem] lg:max-h-[10rem] lg:min-w-30 lg:max-w-[30rem] object-contain mx-20'
          />
        </div>

        <p className='text-base sm:text-base md:text-xl lg:text-xl font-rubik'>Your cart is empty</p>
        <p className='text-sm sm:text-sm md:text-base lg:text-base text-[#9E9E9E] mb-4 font-poppins'>
          let’s fill it up!
        </p>

        <a
          href='/products'
          className='bg-[#C12E2A] hover:bg-[#a52823ff] text-white px-5 py-2 rounded-md text-xs sm:text-xs md:text-sm lg:text-sm font-medium transition-all font-poppins'
        >
          Browse Products
        </a>
      </div>
    </>
  );
};

export default EmptyCartModal;
